// src/components/common/LevelBadge.tsx
import React from "react";
import "../../src/assets/css/global/LevelBadge.css";

type Props = {
	level: number;
};

const getBaseUrl = () => {
	if (typeof window === "undefined") return "";
	return window.location.origin;
};

/**
 * 레벨 → 아이콘 파일명
 * 1  -> 001.gif
 * 9  -> 009.gif
 * 10 -> 010.gif
 * 100 -> 100.gif
 */
const getIconFileNameByLevel = (level: number): string => {
	const safeLevel = Math.max(1, Math.min(level, 100));
	return `${safeLevel.toString().padStart(3, "0")}.gif`;
};

export default function LevelBadge({ level }: Props) {
	const iconFileName = getIconFileNameByLevel(level);
	const iconUrl = `${getBaseUrl()}/images/level/${iconFileName}`;

	return (
		<span className="level-badge">
			<img
				src={iconUrl}
				alt={`level-${level}`}
				className="level-icon"
				loading="lazy"
			/>
		</span>
	);
}
